import ReportsMenu from './ReportsMenu';
export default ReportsMenu;